import LoadingLayout from './LoadingLayout';

export default LoadingLayout;
